/** @deprecated since v5. */
export enum TerraButtonColorEnum {
    IS_PRIMARY = '#24B3E0', // var(--color-active)
    IS_SECONDARY = '#F11539', // var(--color-alert)
    IS_TERTIARY = '#6AD26A' // var(--color-add)
}
